import React from "react";
import Menubar from "../Menubar";

export default function PlanningReports() {

    return (
        <>   <Menubar />
            <div>
                <iframe src="https://app.powerbi.com/view?r=eyJrIjoiOTMyMDFkNjEtZmQ0Yy00YTJhLWI4NzQtZmVhYmNmZTUyZTMwIiwidCI6ImQ2MWUyNGQ2LWQyZWEtNDA0NS05ZGRjLTA2Y2QyMWU2YTE0OSJ9" width="100%" height="100%" style={{ border: "none", height: "100vh" }} title="Power BI Report" allowFullScreen sandbox="allow-same-origin allow-scripts allow-forms allow-popups" referrerPolicy="no-referrer-when-downgrade" />
            </div>
        </>
    );
}